module.exports = __webpack_public_path__ + "fonts/TBCSailec-Regular.7d1ac3fb.eot";